export default "__VITE_ASSET__572e7e09__"